import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../containers/Home";
import ReportsPage from "../containers/Reports";
import OrdersPage from "../containers/Orders";
import OrderPage from "../containers/Order";
import OrderEditPage from "../containers/OrderEdit";
import OrderFundsPage from "../containers/OrderFunds";

function AppRoutes({ navigation, loggedIn = false }) {
  const PrivateRoute = ({ children }) => {
    if (!loggedIn) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <Routes>
      <Route path="/" element={<HomePage loggedIn={loggedIn} />} />

      {/* Reports Route */}
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <ReportsPage navigation={navigation} loggedIn={loggedIn} />
          </PrivateRoute>
        }
      />

      {/* Orders Routes */}
      <Route
        path="/orders"
        element={
          <PrivateRoute>
            <OrdersPage navigation={navigation} loggedIn={loggedIn} />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/:id"
        element={
          <PrivateRoute>
            <OrderPage navigation={navigation} loggedIn={loggedIn} />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/edit/:id"
        element={
          <PrivateRoute>
            <OrderEditPage navigation={navigation} loggedIn={loggedIn} />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/funds/:id"
        element={
          <PrivateRoute>
            <OrderFundsPage navigation={navigation} loggedIn={loggedIn} />
          </PrivateRoute>
        }
      />

    </Routes>
  );
}

export default AppRoutes;
